angular.module('unergie.main')
.factory('ContractConstants', () => {
    const urgencesList = [
        {
            label: 'Standard (5J ouvrés)',
            value: 'NORMAL',
            text: undefined,
        }, {
            label: 'Express (2J ouvrés)',
            value: 'EXPRESS',
            text: 'Attention : la disponibilité d\'Enedis dans les 2 jours ouvrés n\'est pas garantie. ' +
        'Si Enedis ne parvient pas à honorer ce délai, la mise en service sera requalifiée en "Standard" et facturée au prix d\'une mise en service Standard',
        }, {
            label: 'Journée',
            value: 'TODAY',
            text: 'Attention : la disponibilité d\'Enedis dans la journée n\'est pas garantie. ' +
        'Si Enedis ne parvient pas à honorer l\'activation dans la journée, la mise en service sera requalifiée en "Express" et facturée au prix d\'une mise en service Express',
        },
    ]
    const urgencesOtPsList = [
        {
            label: 'Standard (10J ouvrés)',
            value: false,
            text: undefined,
        }, {
            label: 'Express (5J ouvrés)',
            value: true,
            text: 'Attention : la disponibilité d\'Enedis dans les 5 jours ouvrés n\'est pas garantie. ' +
        'Si Enedis ne parvient pas à honorer ce délai, la modification sera requalifiée en "Standard" et facturée au prix d\'une modification Standard',
        },
    ]
    const urgencesCDFInter = [
        {
            label: 'Standard (10J ouvrés)',
            value: 'NORMAL',
            text: undefined,
        }, {
            label: 'Express (5J ouvrés)',
            value: 'EXPRESS',
            text: 'Attention : la disponibilité d\'Enedis dans les 5 jours ouvrés n\'est pas garantie. ' +
        'Si Enedis ne parvient pas à honorer ce délai, la mise en service sera requalifiée en "Standard" et facturée au prix d\'une mise en service Standard',
        },
    ]
    const urgencesFirstMES = [
        {
            label: 'Standard (10J ouvrés)',
            value: 'NORMAL',
            text: undefined,
        }, {
            label: 'Express (5J ouvrés)',
            value: 'EXPRESS',
            text: 'Attention : la disponibilité d\'Enedis dans les 5 jours ouvrés n\'est pas garantie. ' +
        'Si Enedis ne parvient pas à honorer ce délai, la mise en service sera requalifiée en "Standard" et facturée au prix d\'une mise en service Standard',
        }
    ]
    const slotList = [
        { id: 'JOU', label: 'Journée entière' },
        { id: 'DMA', label: 'Début de matinée' },
        { id: 'FMA', label: 'Fin de matinée' },
        { id: 'MAT', label: 'Matinée' },
        { id: 'DAP', label: 'Début d\'après midi' },
        { id: 'FAP', label: 'Fin d\'après midi' },
        { id: 'APM', label: 'Après midi' },
        { id: 'FJO', label: 'Fin de journée' },
        { id: 'DSO', label: 'Début de soirée' },
        { id: 'MJO', label: 'Milieu de journée' },
        { id: 'SOI', label: 'Soirée' },
        { id: 'FSO', label: 'Fin de soirée' },
    ]
    const allPowers = []
    for (let pow = 0.1; pow <= 36; pow = Number((pow + 0.1).toFixed(1))) {
        allPowers.push({ label: `${pow}kVA`, value: pow })
    }
    const ref = {
        allPowers,
        powersBASE: [
            { label: '3kVA', value: 3 },
            { label: '6kVA', value: 6 },
            { label: '9kVA', value: 9 },
            { label: '12kVA', value: 12 },
            { label: '15kVA', value: 15 },
            { label: '18kVA', value: 18 },
            { label: '24kVA', value: 24 },
            { label: '30kVA', value: 30 },
            { label: '36kVA', value: 36 },
        ],
        powersHPHC: [
            { label: '6kVA', value: 6 },
            { label: '9kVA', value: 9 },
            { label: '12kVA', value: 12 },
            { label: '15kVA', value: 15 },
            { label: '18kVA', value: 18 },
            { label: '24kVA', value: 24 },
            { label: '30kVA', value: 30 },
            { label: '36kVA', value: 36 },
        ],
        powersLU: [
            { label: '0.1kVA', value: 0.1 },
            { label: '0.2kVA', value: 0.2 },
            { label: '0.3kVA', value: 0.3 },
            { label: '0.4kVA', value: 0.4 },
            { label: '0.5kVA', value: 0.5 },
            { label: '0.6kVA', value: 0.6 },
            { label: '0.7kVA', value: 0.7 },
            { label: '0.8kVA', value: 0.8 },
            { label: '0.9kVA', value: 0.9 },
            { label: '1kVA', value: 1 },
            { label: '1.1kVA', value: 1.1 },
            { label: '1.2kVA', value: 1.2 },
            { label: '1.3kVA', value: 1.3 },
            { label: '1.4kVA', value: 1.4 },
            { label: '1.5kVA', value: 1.5 },
            { label: '1.6kVA', value: 1.6 },
            { label: '1.7kVA', value: 1.7 },
            { label: '1.8kVA', value: 1.8 },
            { label: '1.9kVA', value: 1.9 },
            { label: '2kVA', value: 2 },
            { label: '2.1kVA', value: 2.1 },
            { label: '2.2kVA', value: 2.2 },
            { label: '2.3kVA', value: 2.3 },
            { label: '2.4kVA', value: 2.4 },
            { label: '2.5kVA', value: 2.5 },
            { label: '2.6kVA', value: 2.6 },
            { label: '2.7kVA', value: 2.7 },
            { label: '2.8kVA', value: 2.8 },
            { label: '2.9kVA', value: 2.9 },
            { label: '3kVA', value: 3 },
        ],
        contexts: [
            { label: 'Éclairage public', value: 'ECPU' },
            { label: 'Usage plat ou Intensif de nuit', value: 'UPIN' },
            { label: 'Autre usage', value: 'AUSA' },
        ],
        packages: [
            { label: '2 350h (forfait nuit)', value: '2350' },
            { label: '4 100h (forfait nuit permanent)', value: '4100' },
            { label: '8 760h (forfait permanent)', value: '8760' },
        ],
        ftas: [
            { value: 'BTINFCUST', label: 'BTINFCUST - Courte utilisation sans diff. temporelle' },
            { value: 'BTINFMUDT', label: 'BTINFMUDT - Moyenne utilisation avec diff. temporelle' },
            { value: 'BTINFCU4', label: 'BTINFCU4 - Courte utilisation 4 classes temporelles' },
            { value: 'BTINFMU4', label: 'BTINFMU4 - Moyenne utilisation 4 classes temporelles' },
            { value: 'BTINFLU', label: 'BTINFLU - Longue utilisation' },
            { value: 'BTSUPCU4', label: 'BTSUPCU4 - Courte utilisation 4 classes temporelles' },
            { value: 'BTSUPLU4', label: 'BTSUPLU4 - Longue utilisation 4 classes temporelles' },
            { value: 'HTACU5', label: 'HTACU5 - Courte utilisation 5 classes temporelles' },
            { value: 'HTALU5', label: 'HTALU5 - Longue utilisation 5 classes temporelles' },
            { value: 'HTACU5-PM', label: 'HTACU5-PM - Courte utilisation 5 classes temporelles ac pointe mobile' },
            { value: 'HTALU5-PM', label: 'HTALU5-PM - Longue utilisation 5 classes temporelles ac pointe mobile' },
        ],
    }
    ref.powersSSCPT = _.uniqBy(ref.powersLU.concat(ref.powersBASE), 'value')
    const urgencesComLinky = [
        {
            label: 'Standard (5J ouvrés)',
            value: 'NORMAL',
            text: undefined,
        }, {
            label: 'Journée',
            value: 'TODAY',
            text: 'Attention : la disponibilité d\'Enedis dans la journée n\'est pas garantie. ' +
            'Si Enedis ne parvient pas à honorer l\'activation dans la journée, la mise en service sera requalifiée en "Express" et facturée au prix d\'une mise en service Express' },
    ]
    const status = {
        INITIAL: 0,
        DEMANDE_TRANSMISE: 1,
        EN_SERVICE: 2,
        EN_RECROUVEMENT: 3,
        RESILIE: 4,
        COUP_LIMI: 5,
        AUTRE: 6,
        ERREUR_ACTIV_ENEDIS: 9,
        DEMANDE_A_TRANSMETTRE: 10,
        RESILIATION_DEMANDEE: 14,
        COUP_LIMI_DEMANDEE: 15,
        EN_ATTENTE_ECHEANCIER: 80,
        EN_ATTENTE_RELEVE_DE_SWITCH: 81,
        PROC_MAN_MES_INTER: 82,
        PROC_MAN_1ER_MES: 83,
        WARNING_DUPLICAT: 84,
        RETRACTE: 90,
        ANNULE: 91,
        EN_ATTENTE: 92,
        CONTRACT_EN_CREATION: -1,
    }
    return {
        ref,
        status,
        slotList,
        urgencesCDFInter,
        urgencesComLinky,
        urgencesOtPsList,
        urgencesList,
        urgencesFirstMES,
    }
})
